// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itaexitpg-inline-1 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
}

.itaexitpg-inline-2 {
  margin-bottom: 16px;
}

.itaexitpg-inline-3 {
  margin-bottom: 8px;
}

.itaexitpg-inline-4 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

.itaexitpg-inline-5 {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px;
}

.itaexitpg-inline-6 {
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 6px;
}

.itaexitpg-inline-7 {
  font-size: 12px;
}

.itaexitpg-inline-8 {
  font-size: 12px;
  color: #94a3b8;
}

.itaexitpg-inline-9 {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px;
}

.itaexitpg-inline-10 {
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 6px;
  color: #b91c1c;
}

.itaexitpg-inline-11 {
  font-size: 12px;
}

.itaexitpg-inline-12 {
  font-size: 12px;
  color: #94a3b8;
}

.itaexitpg-inline-13 {
  margin-top: 8px;
}

.itaexitpg-inline-14 {
  margin-top: 10px;
}

.itaexitpg-inline-15 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 12px;
}

.itaexitpg-inline-16 {
  margin-bottom: 16px;
  overflow: visible;
  position: relative;
  z-index: 999;
}

.itaexitpg-inline-17 {
  overflow: visible;
}

.itaexitpg-inline-18 {
  position: relative;
  max-width: 450px;
  z-index: 100;
}

.itaexitpg-inline-19 {
  font-size: 13px;
}

.itaexitpg-inline-20 {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0,0,0,.12);
  z-index: 9999;
  max-height: 250px;
  overflow-y: auto;
  margin-top: 4px;
}

.itaexitpg-inline-21 {
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.itaexitpg-inline-22 {
  font-size: 13px;
  font-weight: 600;
}

.itaexitpg-inline-23 {
  font-size: 11px;
  color: #94a3b8;
}

.itaexitpg-inline-24 {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 14px;
  text-align: center;
  color: #94a3b8;
  font-size: 12px;
  margin-top: 4px;
  z-index: 50;
}

.itaexitpg-inline-25 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
  font-size: 13px;
}

.itaexitpg-inline-26 {
  background: linear-gradient(135deg,#0f172a 0%,#1e1b4b 50%,#312e81 100%);
  border-radius: 12px;
  padding: 18px 22px;
  color: #fff;
  margin-bottom: 16px;
  position: relative;
  overflow: hidden;
}

.itaexitpg-inline-27 {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.itaexitpg-inline-28 {
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 2px;
}

.itaexitpg-inline-29 {
  font-size: 12px;
  color: rgba(148,163,184,.8);
}

.itaexitpg-inline-30 {
  background: #6366f1;
  padding: 4px 12px;
  border-radius: 8px;
  font-family: monospace;
  font-size: 12px;
  font-weight: 700;
  display: inline-block;
  margin-top: 8px;
}

.itaexitpg-inline-31 {
  text-align: right;
}

.itaexitpg-inline-32 {
  font-size: 11px;
  color: rgba(148,163,184,.6);
}

.itaexitpg-inline-33 {
  width: 120px;
  height: 6px;
  background: rgba(255,255,255,.15);
  border-radius: 10px;
  margin-top: 6px;
  overflow: hidden;
}

.itaexitpg-inline-34 {
  text-align: center;
  padding: 40px;
}

.itaexitpg-inline-35 {
  font-size: 36px;
  margin-bottom: 8px;
}

.itaexitpg-inline-36 {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
}

.itaexitpg-inline-37 {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 4px;
}

.itaexitpg-inline-38 {
  margin-bottom: 16px;
}

.itaexitpg-inline-39 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.itaexitpg-inline-40 {
  padding: 0;
}

.itaexitpg-inline-41 {
  width: 20px;
  height: 20px;
  accent-color: #2563eb;
  cursor: pointer;
  flex-shrink: 0;
}

.itaexitpg-inline-42 {
  flex: 1 1;
}

.itaexitpg-inline-43 {
  font-size: 11px;
  color: #94a3b8;
}

.itaexitpg-inline-44 {
  font-size: 10px;
  color: #2563eb;
  font-weight: 600;
  text-align: right;
  flex-shrink: 0;
}

.itaexitpg-inline-45 {
  color: #94a3b8;
  font-weight: 400;
}

.itaexitpg-inline-46 {
  margin-bottom: 16px;
}

.itaexitpg-inline-47 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.itaexitpg-inline-48 {
  padding: 0;
}

.itaexitpg-inline-49 {
  width: 20px;
  height: 20px;
  accent-color: #2563eb;
  cursor: pointer;
  flex-shrink: 0;
}

.itaexitpg-inline-50 {
  flex: 1 1;
}

.itaexitpg-inline-51 {
  font-size: 11px;
  color: #94a3b8;
}

.itaexitpg-inline-52 {
  font-size: 10px;
  color: #2563eb;
  font-weight: 600;
  text-align: right;
  flex-shrink: 0;
}

.itaexitpg-inline-53 {
  color: #94a3b8;
  font-weight: 400;
}

.itaexitpg-inline-54 {
  margin-bottom: 16px;
}

.itaexitpg-inline-55 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.itaexitpg-inline-56 {
  padding: 0;
}

.itaexitpg-inline-57 {
  width: 20px;
  height: 20px;
  accent-color: #2563eb;
  cursor: pointer;
  flex-shrink: 0;
}

.itaexitpg-inline-58 {
  flex: 1 1;
}

.itaexitpg-inline-59 {
  font-size: 11px;
  color: #94a3b8;
}

.itaexitpg-inline-60 {
  font-size: 10px;
  color: #2563eb;
  font-weight: 600;
  text-align: right;
  flex-shrink: 0;
}

.itaexitpg-inline-61 {
  color: #94a3b8;
  font-weight: 400;
}

.itaexitpg-inline-62 {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  margin-bottom: 24px;
}

.itaexitpg-inline-63 {
  font-size: 12px;
  color: #94a3b8;
  font-style: italic;
  padding: 12px 0;
}

.itaexitpg-inline-64 {
  margin-top: 16px;
}

.itaexitpg-inline-65 {
  padding: 0;
}

.itaexitpg-inline-66 {
  font-weight: 600;
}

.itaexitpg-inline-67 {
  font-family: monospace;
  font-size: 11px;
}

.itaexitpg-inline-68 {
  font-size: 11px;
}

.itaexitpg-inline-69 {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  background: #eff6ff;
  color: #2563eb;
}

.itaexitpg-dyn-1 {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  background: var(--itaexitpg-1-background);
  color: var(--itaexitpg-1-color);
}

.itaexitpg-dyn-2 {
  position: absolute;
  top: var(--itaexitpg-2-top);
  right: var(--itaexitpg-2-right);
  width: 140px;
  height: 140px;
  background: radial-gradient(circle,rgba(99,102,241,.15),transparent 70%);
  border-radius: 50%;
}

.itaexitpg-dyn-3 {
  font-size: 28px;
  font-weight: 800;
  color: var(--itaexitpg-3-color);
}

.itaexitpg-dyn-4 {
  width: var(--itaexitpg-4-width);
  height: 100%;
  background: var(--itaexitpg-4-background);
  border-radius: 10px;
  transition: width 0.3s;
}

.itaexitpg-dyn-5 {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  border-bottom: var(--itaexitpg-5-border-bottom);
  background: var(--itaexitpg-5-background);
  transition: background 0.2s;
}

.itaexitpg-dyn-6 {
  font-size: 13px;
  font-weight: 600;
  color: var(--itaexitpg-6-color);
  text-decoration: var(--itaexitpg-6-text-decoration);
}

.itaexitpg-dyn-7 {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  border-bottom: var(--itaexitpg-7-border-bottom);
  background: var(--itaexitpg-7-background);
  transition: background 0.2s;
}

.itaexitpg-dyn-8 {
  font-size: 13px;
  font-weight: 600;
  color: var(--itaexitpg-8-color);
  text-decoration: var(--itaexitpg-8-text-decoration);
}

.itaexitpg-dyn-9 {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  border-bottom: var(--itaexitpg-9-border-bottom);
  background: var(--itaexitpg-9-background);
  transition: background 0.2s;
}

.itaexitpg-dyn-10 {
  font-size: 13px;
  font-weight: 600;
  color: var(--itaexitpg-10-color);
  text-decoration: var(--itaexitpg-10-text-decoration);
}

.itaexitpg-dyn-11 {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 12px 28px;
  font-size: 14px;
  font-weight: 700;
  cursor: var(--itaexitpg-11-cursor);
  box-shadow: 0 4px 12px rgba(22,163,74,.3);
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: var(--itaexitpg-11-opacity);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ITAdmin/ITAExitPg.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uEAAuE;EACvE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,wEAAwE;EACxE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;AACtC","sourcesContent":[".itaexitpg-inline-1 {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 16px;\n}\n\n.itaexitpg-inline-2 {\n  margin-bottom: 16px;\n}\n\n.itaexitpg-inline-3 {\n  margin-bottom: 8px;\n}\n\n.itaexitpg-inline-4 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.itaexitpg-inline-5 {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n.itaexitpg-inline-6 {\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.itaexitpg-inline-7 {\n  font-size: 12px;\n}\n\n.itaexitpg-inline-8 {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.itaexitpg-inline-9 {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n.itaexitpg-inline-10 {\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 6px;\n  color: #b91c1c;\n}\n\n.itaexitpg-inline-11 {\n  font-size: 12px;\n}\n\n.itaexitpg-inline-12 {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.itaexitpg-inline-13 {\n  margin-top: 8px;\n}\n\n.itaexitpg-inline-14 {\n  margin-top: 10px;\n}\n\n.itaexitpg-inline-15 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2563eb;\n  margin-bottom: 12px;\n}\n\n.itaexitpg-inline-16 {\n  margin-bottom: 16px;\n  overflow: visible;\n  position: relative;\n  z-index: 999;\n}\n\n.itaexitpg-inline-17 {\n  overflow: visible;\n}\n\n.itaexitpg-inline-18 {\n  position: relative;\n  max-width: 450px;\n  z-index: 100;\n}\n\n.itaexitpg-inline-19 {\n  font-size: 13px;\n}\n\n.itaexitpg-inline-20 {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0,0,0,.12);\n  z-index: 9999;\n  max-height: 250px;\n  overflow-y: auto;\n  margin-top: 4px;\n}\n\n.itaexitpg-inline-21 {\n  padding: 10px 14px;\n  cursor: pointer;\n  border-bottom: 1px solid #f1f5f9;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.itaexitpg-inline-22 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.itaexitpg-inline-23 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.itaexitpg-inline-24 {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 14px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 12px;\n  margin-top: 4px;\n  z-index: 50;\n}\n\n.itaexitpg-inline-25 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.itaexitpg-inline-26 {\n  background: linear-gradient(135deg,#0f172a 0%,#1e1b4b 50%,#312e81 100%);\n  border-radius: 12px;\n  padding: 18px 22px;\n  color: #fff;\n  margin-bottom: 16px;\n  position: relative;\n  overflow: hidden;\n}\n\n.itaexitpg-inline-27 {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.itaexitpg-inline-28 {\n  font-size: 17px;\n  font-weight: 700;\n  margin-bottom: 2px;\n}\n\n.itaexitpg-inline-29 {\n  font-size: 12px;\n  color: rgba(148,163,184,.8);\n}\n\n.itaexitpg-inline-30 {\n  background: #6366f1;\n  padding: 4px 12px;\n  border-radius: 8px;\n  font-family: monospace;\n  font-size: 12px;\n  font-weight: 700;\n  display: inline-block;\n  margin-top: 8px;\n}\n\n.itaexitpg-inline-31 {\n  text-align: right;\n}\n\n.itaexitpg-inline-32 {\n  font-size: 11px;\n  color: rgba(148,163,184,.6);\n}\n\n.itaexitpg-inline-33 {\n  width: 120px;\n  height: 6px;\n  background: rgba(255,255,255,.15);\n  border-radius: 10px;\n  margin-top: 6px;\n  overflow: hidden;\n}\n\n.itaexitpg-inline-34 {\n  text-align: center;\n  padding: 40px;\n}\n\n.itaexitpg-inline-35 {\n  font-size: 36px;\n  margin-bottom: 8px;\n}\n\n.itaexitpg-inline-36 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.itaexitpg-inline-37 {\n  font-size: 12px;\n  color: #94a3b8;\n  margin-top: 4px;\n}\n\n.itaexitpg-inline-38 {\n  margin-bottom: 16px;\n}\n\n.itaexitpg-inline-39 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.itaexitpg-inline-40 {\n  padding: 0;\n}\n\n.itaexitpg-inline-41 {\n  width: 20px;\n  height: 20px;\n  accent-color: #2563eb;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.itaexitpg-inline-42 {\n  flex: 1;\n}\n\n.itaexitpg-inline-43 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.itaexitpg-inline-44 {\n  font-size: 10px;\n  color: #2563eb;\n  font-weight: 600;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.itaexitpg-inline-45 {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.itaexitpg-inline-46 {\n  margin-bottom: 16px;\n}\n\n.itaexitpg-inline-47 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.itaexitpg-inline-48 {\n  padding: 0;\n}\n\n.itaexitpg-inline-49 {\n  width: 20px;\n  height: 20px;\n  accent-color: #2563eb;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.itaexitpg-inline-50 {\n  flex: 1;\n}\n\n.itaexitpg-inline-51 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.itaexitpg-inline-52 {\n  font-size: 10px;\n  color: #2563eb;\n  font-weight: 600;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.itaexitpg-inline-53 {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.itaexitpg-inline-54 {\n  margin-bottom: 16px;\n}\n\n.itaexitpg-inline-55 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.itaexitpg-inline-56 {\n  padding: 0;\n}\n\n.itaexitpg-inline-57 {\n  width: 20px;\n  height: 20px;\n  accent-color: #2563eb;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.itaexitpg-inline-58 {\n  flex: 1;\n}\n\n.itaexitpg-inline-59 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.itaexitpg-inline-60 {\n  font-size: 10px;\n  color: #2563eb;\n  font-weight: 600;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.itaexitpg-inline-61 {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.itaexitpg-inline-62 {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 8px;\n  margin-bottom: 24px;\n}\n\n.itaexitpg-inline-63 {\n  font-size: 12px;\n  color: #94a3b8;\n  font-style: italic;\n  padding: 12px 0;\n}\n\n.itaexitpg-inline-64 {\n  margin-top: 16px;\n}\n\n.itaexitpg-inline-65 {\n  padding: 0;\n}\n\n.itaexitpg-inline-66 {\n  font-weight: 600;\n}\n\n.itaexitpg-inline-67 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.itaexitpg-inline-68 {\n  font-size: 11px;\n}\n\n.itaexitpg-inline-69 {\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.itaexitpg-dyn-1 {\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  background: var(--itaexitpg-1-background);\n  color: var(--itaexitpg-1-color);\n}\n\n.itaexitpg-dyn-2 {\n  position: absolute;\n  top: var(--itaexitpg-2-top);\n  right: var(--itaexitpg-2-right);\n  width: 140px;\n  height: 140px;\n  background: radial-gradient(circle,rgba(99,102,241,.15),transparent 70%);\n  border-radius: 50%;\n}\n\n.itaexitpg-dyn-3 {\n  font-size: 28px;\n  font-weight: 800;\n  color: var(--itaexitpg-3-color);\n}\n\n.itaexitpg-dyn-4 {\n  width: var(--itaexitpg-4-width);\n  height: 100%;\n  background: var(--itaexitpg-4-background);\n  border-radius: 10px;\n  transition: width 0.3s;\n}\n\n.itaexitpg-dyn-5 {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 20px;\n  border-bottom: var(--itaexitpg-5-border-bottom);\n  background: var(--itaexitpg-5-background);\n  transition: background 0.2s;\n}\n\n.itaexitpg-dyn-6 {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--itaexitpg-6-color);\n  text-decoration: var(--itaexitpg-6-text-decoration);\n}\n\n.itaexitpg-dyn-7 {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 20px;\n  border-bottom: var(--itaexitpg-7-border-bottom);\n  background: var(--itaexitpg-7-background);\n  transition: background 0.2s;\n}\n\n.itaexitpg-dyn-8 {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--itaexitpg-8-color);\n  text-decoration: var(--itaexitpg-8-text-decoration);\n}\n\n.itaexitpg-dyn-9 {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 20px;\n  border-bottom: var(--itaexitpg-9-border-bottom);\n  background: var(--itaexitpg-9-background);\n  transition: background 0.2s;\n}\n\n.itaexitpg-dyn-10 {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--itaexitpg-10-color);\n  text-decoration: var(--itaexitpg-10-text-decoration);\n}\n\n.itaexitpg-dyn-11 {\n  background: linear-gradient(135deg, #2563eb, #1d4ed8);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  padding: 12px 28px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: var(--itaexitpg-11-cursor);\n  box-shadow: 0 4px 12px rgba(22,163,74,.3);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  opacity: var(--itaexitpg-11-opacity);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
